<section class="tooltip-generic tooltip-enabled" #tooltipGeneric
         [ngStyle]=tooltipStyle>
  <span class="tooltip-arrow tooltip-arrow-{{tooltipPosition | lowercase }}">
  </span>
  <div class="tooltip-title" *ngIf="tooltipConfiguration?.tooltipTitle">{{tooltipConfiguration?.tooltipTitle}}</div>
  <span class="tooltip-content" translate>
        <ng-content></ng-content>
  </span>
</section>